/* ⚠️ GENERATED from app/services/postCounts.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/postCounts.ts — a post document becomes a post, counters and all.
//
// 🟥 THE COUNTERS ARE DERIVED, AND THEY WERE DERIVED IN FIVE PLACES. A like is
//    stored as `likes: arrayUnion(uid)` — the ARRAY is the truth, and the
//    document carries no `likesCount` field at all (screens/VibesScreen.tsx
//    writes `likes: []` and never a counter). Three of the five map sites knew
//    that and recomputed; two spread the raw document and shipped
//    `likesCount: undefined`.
//
//    That is the bug you can see: like your own post, refresh, and the count
//    falls back to 0 while the heart stays red — because the heart reads
//    `likes.includes(uid)`, which was right all along, and the number read a
//    field that was never written. It only showed on your OWN recent posts,
//    because those are the two paths that took the shortcut: the "my posts from
//    the last hour" list that is prepended to a ranked page, and the profile
//    grid's own listener.
//
// 🟥 SO THERE IS ONE MAPPER NOW, and the fix is that there is only one. The same
//    class of bug already cost this codebase a round on the server side — see
//    the note about `commentsCount` in server/functions/trending.js, which is
//    this exact mistake one field along.
//
// 🟢 PURE. A twin is generated for the web.

import { commentCountOf } from './vibeComments';
import { likeTotalOf } from './likeLedger';

/**
 * How many likes a post has, for display.
 *
 * 🟢 THE ARRAY WINS WHENEVER THERE IS ONE. A persisted counter is only ever a
 *    fallback for a document shape that predates the array, never an override.
 */
export function likeCountOf(post) {
  /* ❤️ past 500 likers the array is only a ledger — the shared rule
     (services/likeLedger.ts) reads the server's counter for those posts */
  return likeTotalOf(post);
}
export function shareCountOf(post) {
  return Math.max(0, Number(post?.sharesCount) || 0);
}

/**
 * A Firestore post document as the feed uses it.
 *
 * 🟥 EVERY PLACE THAT TURNS A POST DOCUMENT INTO A POST GOES THROUGH HERE. Not
 *    because spreading `...data` is wrong, but because the derived fields have
 *    to be added afterwards and "afterwards" is what gets forgotten.
 */
export function postFromDoc(id, data) {
  const d = data || {};
  return {
    ...d,
    id,
    likesCount: likeCountOf(d),
    commentsCount: commentCountOf(d),
    sharesCount: shareCountOf(d),
    viewsCount: Math.max(0, Number(d.viewsCount) || 0),
    reachCount: Math.max(0, Number(d.reachCount) || 0)
  };
}
